import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { IdentityService } from '../services/identity.service'
import { ContractPdfComponent } from './components/contract-pdf/contract-pdf.component'
import { DealSummaryComponent } from './components/deal-summary/deal-summary.component'
import { DealSigningPersonsComponent } from './components/deal-signing-persons/deal-signing-persons.component'
import { DealDashboardComponent } from './components/deal-dashboard/deal-dashboard.component'
import { DealIdentityComponent } from './components/deal-identity/deal-identity.component'
import { DealOnfidoComponent } from './components/deal-onfido/deal-onfido.component'
import { PreviewModel3Component } from './components/preview-model-3/preview-model-3.component'
import { PreviewModelYComponent } from './components/preview-model-y/preview-model-y.component'
import { PreviewModelSComponent } from './components/preview-model-s/preview-model-s.component'
import { PreviewModelXComponent } from './components/preview-model-x/preview-model-x.component'
import { DealUserProfileComponent } from './components/deal-user-profile/deal-user-profile.component'
import { DealAddressComponent } from './components/deal-address/deal-address.component'
import { ReferralCelebrationPopupComponent } from './components/referral-celebration-popup/referral-celebration-popup.component'
import { UiModule } from '../../../ui/monolith/ui.module'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatRadioModule } from '@angular/material/radio'
import { OptionTranslationPipe } from './pipes/option-translation.pipe'
import { PreviewTesla } from './components/preview-tesla/preview-tesla.component'
import { DealBijtellingComponent } from './components/deal-bijtelling/deal-bijtelling.component'
import { MatSelectModule } from '@angular/material/select'
import { MatFormFieldModule } from '@angular/material/form-field'
import { TenantCurrencyModule } from 'framework/tenant-currency/tenant-currency.module'
import { PromoCodeService } from '../services/promo-code.service'
import { TeslaEmployeePromoCodeComponent } from './components/tesla-employee-promo-code/tesla-employee-promo-code.component'
import { DealVaaAtnComponent } from './components/deal-vaa-atn/deal-vaa-atn.component'
import { MatDialogModule } from '@angular/material/dialog'
import { InteriorViewModelYComponent } from './components/interior-view-model-y/interior-view-model-y.component'

const components = [
    DealIdentityComponent,
    DealOnfidoComponent,
    ContractPdfComponent,
    DealSummaryComponent,
    DealSigningPersonsComponent,
    PreviewModel3Component,
    PreviewModelYComponent,
    PreviewModelSComponent,
    PreviewModelXComponent,
    PreviewTesla,
    DealAddressComponent,
    DealDashboardComponent,
    DealUserProfileComponent,
    DealBijtellingComponent,
    ReferralCelebrationPopupComponent,
    OptionTranslationPipe,
    TeslaEmployeePromoCodeComponent,
    DealVaaAtnComponent,
    InteriorViewModelYComponent,
]

@NgModule({
    imports: [
        CommonModule,
        UiModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatButtonModule,
        MatCheckboxModule,
        MatIconModule,
        MatInputModule,
        MatRadioModule,
        MatProgressSpinnerModule,
        MatSelectModule,
        TenantCurrencyModule,
        MatDialogModule,
    ],
    declarations: components,
    exports: components,
    providers: [IdentityService, PromoCodeService],
})
export class DealUiModule {}
